;(function () {
  'use strict'

  angular.module('admin.blockchain.service', []).factory('BlockchainService', BlockchainService)

  /** @ngInject */
  function BlockchainService($http, $q, API) {
    function listBlockchains(start, limit) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/blockchains?start=' + start + '&limit=' + limit)
        .success(defered.resolve)

      return defered.promise
    }

    function getBlockchain(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/blockchains/' + id).success(defered.resolve)

      return defered.promise
    }

    function saveBlockchain(model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/blockchains', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function updateBlockchain(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/blockchains/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeBlockchain(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/blockchains/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listSmartContracts(start, limit) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/smart_contracts?start=' + start + '&limit=' + limit)
        .success(defered.resolve)

      return defered.promise
    }

    function getSmartContracts(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/smart_contracts/' + id).success(defered.resolve)

      return defered.promise
    }

    function saveSmartContracts(model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/smart_contracts', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function updateSmartContracts(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/smart_contracts/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeSmartContracts(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/smart_contracts/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listSmartContractDeployments(start, limit) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/smart_contract_deployments?enrich=cmn,cun,cbn&start=' +
            start +
            '&limit=' +
            limit,
        )
        .success(defered.resolve)

      return defered.promise
    }

    function getSmartContractDeployments(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/smart_contract_deployments/' + id).success(defered.resolve)

      return defered.promise
    }

    function saveSmartContractDeployments(model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/smart_contract_deployments', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function updateSmartContractDeployments(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/smart_contract_deployments/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeSmartContractDeployments(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/smart_contract_deployments/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listSmartContractFeatures(start, limit) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/smart_contract_features?start=' + start + '&limit=' + limit)
        .success(defered.resolve)

      return defered.promise
    }

    function getSmartContractFeatures(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/smart_contract_features/' + id).success(defered.resolve)

      return defered.promise
    }

    function saveSmartContractFeatures(model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/smart_contract_features', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function updateSmartContractFeatures(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/smart_contract_features/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeSmartContractFeatures(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/smart_contract_features/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listCollectibles(chId, sId) {
      var defered = $q.defer()

      $http
        .get(
          `${API.API_URL}admin/collectibles/search?enrich=block,scd&mint=true${
            chId ? `&chId=${chId}` : ''
          }${sId ? `&sId=${sId}` : ''}`,
        )
        .success(defered.resolve)

      return defered.promise
    }

    function saveCollectibleSmartContract(scdId, model) {
      var defered = $q.defer()

      $http
        .post(`${API.API_URL}admin/smart_contract_deployments/${scdId}/collectibles`, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function deleteCollectibleSmartContract(scdId, collectibleId) {
      var defered = $q.defer()

      $http
        .delete(`${API.API_URL}admin/smart_contract_deployments/${scdId}/collectibles/${collectibleId}`)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function deleteMultipleCollectibleSmartContract(scdId, model) {
      var defered = $q.defer()

      $http
        .post(`${API.API_URL}admin/smart_contract_deployments/${scdId}/collectibles/delete`, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    return {
      listBlockchains: listBlockchains,
      getBlockchain: getBlockchain,
      saveBlockchain: saveBlockchain,
      updateBlockchain: updateBlockchain,
      removeBlockchain: removeBlockchain,
      listSmartContracts: listSmartContracts,
      getSmartContracts: getSmartContracts,
      saveSmartContracts: saveSmartContracts,
      updateSmartContracts: updateSmartContracts,
      removeSmartContracts: removeSmartContracts,
      listSmartContractDeployments: listSmartContractDeployments,
      getSmartContractDeployments: getSmartContractDeployments,
      saveSmartContractDeployments: saveSmartContractDeployments,
      updateSmartContractDeployments: updateSmartContractDeployments,
      removeSmartContractDeployments: removeSmartContractDeployments,
      listSmartContractFeatures: listSmartContractFeatures,
      getSmartContractFeatures: getSmartContractFeatures,
      saveSmartContractFeatures: saveSmartContractFeatures,
      updateSmartContractFeatures: updateSmartContractFeatures,
      removeSmartContractFeatures: removeSmartContractFeatures,
      listCollectibles,
      saveCollectibleSmartContract,
      deleteCollectibleSmartContract,
      deleteMultipleCollectibleSmartContract,
    }
  }
})()
